document.addEventListener("DOMContentLoaded", init)

function init() {
  const allProducts = document.querySelectorAll('.wp-block-webdevia-all-products')
  if( allProducts.length ) {
    allProducts.forEach( productsBlock => {
      productsBlock.querySelectorAll('button').forEach( navBtn => {
        navBtn.addEventListener( 'click', e => getPage(e, productsBlock) )
      } )

    } )
  }
}

function getPage(e, container) {
  const toPage = e.target.id,
        perPage = container.dataset.perPage,
        maxPages = parseInt(container.dataset.maxPages),
        next = container.querySelector('#next'),
        prev = container.querySelector('#prev'),
        overlay = container.querySelector('.overlay')
  overlay.classList.add('loading')  
  let currentPage = parseInt(container.dataset.currentPage)
  currentPage = toPage == 'next' ? ++currentPage : --currentPage
  if( currentPage == maxPages ) {
    next.disabled = true
  } else next.disabled = false
  if( currentPage == 1 ) {
    prev.disabled = true
  } else prev.disabled = false

  let formData = new FormData()
  formData.append('action', 'wd_get_pagination_page')
  formData.append('per_page', perPage)
  formData.append('current_page', currentPage)
  formData.append('max_pages', maxPages)
  let xhttp = new XMLHttpRequest()
  xhttp.onreadystatechange = () => {
    if( xhttp.readyState == DONE && xhttp.status == OK ) {
      const response = JSON.parse( xhttp.responseText )
      overlay.classList.remove('loading') 
      if( response.success ) {
        if( toPage == 'next' ) {
          container.dataset.currentPage++
        } else container.dataset.currentPage--
        container.querySelector('.products').innerHTML = response.data
      } else {
        console.error( response.data )
      }
    }
  }
  xhttp.onerror = exception => {
    let msg = ''
    if (xhttp.status == 0) {
      msg = 'Not connect.\n Verify Network.'
    } else if (xhttp.status == 404) {
      msg = 'Requested page not found. [404]'
    } else if (xhttp.status == 500) {
      msg = 'Internal Server Error [500].'
    } else if (exception === 'parsererror') {
      msg = 'Requested JSON parse failed.'
    } else if (exception === 'timeout') {
      msg = 'Time out error.'
    } else if (exception === 'abort') {
      msg = 'Ajax request aborted.'
    } else {
      msg = 'Uncaught Error.\n' + xhttp.responseText
    }
    console.error(msg)
  }
  xhttp.open( 'POST', devia.ajax_url, true )
  xhttp.send( formData )
}